import React, { useEffect, useState } from 'react';
import {
  SPECIFIC_LOT_IDENTIFICATION,
  getCostBasisOptions
} from 'services/CostBasisMethod';
import lockIcon from 'assets/icons/lock-2.svg';
import './EditModal.scss';
import { ACTIVE_ADVISORY } from 'services/Products';

import infoIcon from 'assets/icons/info-icon-filled.svg';
import redInfoIcon from 'assets/icons/red-info-icon.svg';
import { ExpandableText } from './ExpandableText';
import { AAMBeaconControl } from 'components/shared/Beacon';

const CostBasisOption = ({
  account,
  brokerageMFChanged = false,
  costBasisTypeId,
  onValueChange,
  curIndex,
  accountInfomation,
  isBrokerageMutualFund = false,
  isBrokerageStockReinvestment = false,
  openModal
}) => {
  const isActiveAdvisory = accountInfomation.productType === ACTIVE_ADVISORY;
  const isBrokerage = accountInfomation.isBrokerage;
  const costBasisMethodOptions = getCostBasisOptions(
    isActiveAdvisory,
    isBrokerage,
    isBrokerageMutualFund,
    isBrokerageStockReinvestment
  );
  const [currElection, setCurrElection] = useState(costBasisTypeId);
  const { accountName, numberWithChecksum = '', ticker } = account;
  const [showNote, setShowNote] = useState(false);
  const handleChange = (e) => {
    setCurrElection(e.target.value);
    setShowNote(parseInt(e.target.value) === SPECIFIC_LOT_IDENTIFICATION);
    onValueChange({ value: parseInt(e.target.value), curIndex });
  };
  const getError = () => {
    if (
      isBrokerage &&
      accountInfomation?.brokerageCostBasisMethods?.recordKeeperStatus
        .brokerageRequestStatus === 'UNKNOWN'
    ) {
      return {
        hasError: true,
        errorMsg: 'Currently Unavailable'
      };
    }
    return {
      hasError: false,
      errorMsg: null
    };
  };
  const getMessage = () => {
    if (isActiveAdvisory) {
      return {
        show: true,
        label: (
          <>
            Minimized Short Term Gains
            <img src={lockIcon} alt="lock" />
          </>
        )
      };
    } else if (accountInfomation.pendingIndicator) {
      return {
        show: true,
        label: <>Changes Pending</>
      };
    }
    return { show: false, label: null };
  };

  useEffect(() => {
    setCurrElection(costBasisTypeId.toString());
    onValueChange({ value: parseInt(costBasisTypeId), curIndex });
  }, [openModal]);

  return (
    <div className="cost-basis-options-container">
      <div className="cost-basis-options">
        <div className="cost-basis-options-title blocked_data">
          <h4>{ticker}</h4>
          <h3 className="cost-basis-options-title-primary  b-font-weight-bold b-typography-sans-serif--body--200">
            {accountName}
          </h3>

          <div className="cost-basis-options-title-secondary">
            {numberWithChecksum}
          </div>
        </div>
        {getMessage().show ? (
          <div className="cost-basis-dropdown cost-basis-show-msg">
            {getMessage().label}
          </div>
        ) : (
          <div className={'cost-basis-dropdown'}>
            {getError().hasError ? (
              <div className="cost-basis-method-select cost-basis-method-select-error-msg">
                <img src={redInfoIcon} alt="info-icon" />
                <h4>{getError().errorMsg}</h4>
              </div>
            ) : (
              <div className="beacon-on-light">
                <AAMBeaconControl>
                  <label slot="label" htmlFor="cost-basis-types-select">
                    Cost Basis Method
                  </label>
                  <select value={currElection}
                    id="cost-basis-types-select"
                    name="cost-basis-types-select"
                    className="cost-basis-method-select"
                    onChange={handleChange}>
                    {costBasisMethodOptions.map((option, index) => (
                      <option
                        key={index + 1}
                        value={option.value}
                        selected={
                          option.value.toString() === currElection.toString()
                        }>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </AAMBeaconControl>
              </div>
            )}
          </div>
        )}
      </div>
      {showNote && (
        <ExpandableText
          hasExpandableText={true}
          primaryText={
            <>
              <img src={infoIcon} alt="info" />{' '}
              <span>
                <strong>Please note: </strong>
                <span>
                  Specific Lot Identification cannot be selected online as a
                  cost basis method for your mutual fund shares, except for
                  shares held in a T. Rowe Price Brokerage account.
                </span>
              </span>
            </>
          }
          secondaryText={
            <>
              <strong>
                To sell or exchange shares using Specific Lot Identification as
                the cost basis method:
              </strong>
              <ol>
                <li>
                  Ensure your current method is not set to Average Cost (if it
                  is, you may change it online to another method such as FIFO)
                </li>
                <li>
                  Call us at 1-888-898-9677 to specify the shares for
                  transaction.
                </li>
              </ol>
            </>
          }
        />
      )}
      {/* Show Brokerage Mutual Fund Change Message */}
      {isBrokerageMutualFund && brokerageMFChanged && (
        <ExpandableText
          hasExpandableText={false}
          primaryText={
            <>
              <img src={infoIcon} alt="info" />{' '}
              <span>
                <strong>Please note: </strong>
                The new cost basis method will be applied to all of the current
                mutual fund positions in your account as well as future mutual
                fund purchases.
              </span>
            </>
          }
        />
      )}
    </div>
  );
};

export default CostBasisOption;
